const HighlightsData = [
    {
        id: 1,
        detail: "Low rise density and all Karma Golf Facing Apartments.",
    },
    {
        id: 2,
        detail: "Previously, Club: A Luxurious Clubhouse Measuring up to 70000 sq. Ft. A great place with world class facilities.",
    },
    {
        id: 3,
        detail: "Total 5 High Rise Tower having G+43 Floor and 5 Wing of G+43 Floor.",
    },
    {
        id: 4,
        detail: "Situated at 31 acres of the Land Parcel; Total Karma Lakeland comprises of 270 acres of the land.",
    },
    {
        id: 5,
        detail: "1st Phase Launching will have 524 Apartments with benefits.",
    },
    {
        id: 6,
        detail: "Operational 9 Hole Golf",
    },
    {
        id: 7,
        detail: "Ground With Viewing Gallery.",
    },
    {
        id: 8,
        detail: "The establishment is a fully functional signature club resort.",
    },
]

export default HighlightsData;